import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { IconButton } from '@mui/material';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { API_URI, END_POINTS, ALERTS } from "./Constants";
import ATSScoreCard from './ATSScoreCard';
import axiosInstance from '../Api/Instance';
const { CANDIDATE } = END_POINTS;
const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 28,
    p: 4,
};

export default function UploadModal(props) {
    const {
        isOpen,
        closeModal,
        score,
        candidateId,
        isJDChecked,
        isMultipleResumeUpload,
    } = props.value;
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = React.useState(false);

    const HandleBackToProfile = async () => {
        try {
            setIsLoading(true);

            const response = await axiosInstance.get(`${CANDIDATE}/${candidateId}`);
            const candidate = response.data;

            setIsLoading(false);
            navigate(`${CANDIDATE}/${candidateId}`, { state: { candidate } });
        } catch (e) {
            setIsLoading(false);
            console.error(ALERTS.FAILED_TO_SWITCH, e.response?.data?.message || e.message);
        }
    };

    const HandleBackToCandidatelist = () => {
        navigate('/candidatelist');
    };

    return (
        <>

            <Modal
                open={isOpen}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <IconButton
                        onClick={closeModal}
                        sx={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            color: 'black',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* UPLOADED RESUME AND PROFILE CHECK */}
                    {!isJDChecked && !isMultipleResumeUpload ? (
                        <div>
                            <Typography
                                id="modal-modal-title"
                                className="text-center font-bold"
                                sx={{ mt: 2 }}
                                variant="h5"
                                component="h1"
                            >
                                Resume successfully uploaded
                            </Typography>
                            <Box display="flex" justifyContent="space-between" gap={4} mt={6}>
                                <Button variant="contained" onClick={HandleBackToProfile}>
                                    Check Profile
                                </Button>
                                <Button variant="outlined" onClick={closeModal}>
                                    Back to Upload Profile
                                </Button>
                            </Box>
                        </div>
                    ) : isMultipleResumeUpload ? (
                        <div>
                            <Typography
                                id="modal-modal-title"
                                className="text-center font-bold"
                                sx={{ mt: 2 }}
                                variant="h5"
                                component="h1"
                            >
                                Resume successfully uploaded
                            </Typography>
                            <Box display="flex" justifyContent="space-between" gap={4} mt={6}>
                                <Button variant="contained" onClick={HandleBackToCandidatelist}>
                                    Check Candidates
                                </Button>
                                <Button variant="outlined" onClick={closeModal}>
                                    Back to Upload Profile
                                </Button>
                            </Box>
                        </div>
                    ) : (
                        <div>
                            <Typography
                                id="modal-modal-title"
                                className="text-center font-bold"
                                sx={{ mt: 2 }}
                                variant="h5"
                                component="h1"
                            >
                                Profile successfully analysed and Applicant's score is
                            </Typography>
                            <Typography className="text-center" sx={{ mt: 2 }}>
                                <ATSScoreCard score={score} />
                            </Typography>
                        </div>
                    )}
                </Box>
            </Modal>
        </>
    );
}
